import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import PatientsGroupsHistory from './PatientsGroupsHistory';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	groupId: string;
	groupName: string;
}

const PatientsGroupsHistoryModal: React.FC<Props> = ({
	isOpen,
	onClose,
	groupId,
	groupName,
}) => {
	const { t } = useTranslation();
	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.XL}>
			<Modal.Header title={`${t('base.history')}: ${groupName}`} firstUpper />
			<Modal.Content>
				<PatientsGroupsHistory groupId={groupId} groupName={groupName} />
			</Modal.Content>
		</Modal>
	);
};

export default PatientsGroupsHistoryModal;
